import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

export const getInvoiceByOrder = createAsyncThunk(
  "invoice/getInvoiceByOrder",
  async (args, thunkAPI) => {
    const { orderId, eventId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/invoices/orders/${orderId}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const getInvoiceById = createAsyncThunk(
  "invoice/getInvoiceById",
  async (args, thunkAPI) => {
    const { invoiceId } = args;
    const response = await axiosInstance.request({
      url: `/invoices/${invoiceId}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const setInvoice = createAsyncThunk(
  "invoice/setInvoice",
  async (args, thunkAPI) => {
    const { data } = args;
    const response = await axiosInstance.request({
      url: `/invoices`,
      method: "post",
      data,
    });
    return { data: response.data };
  }
);

export const validateRfc = createAsyncThunk(
  "invoice/validateRfc",
  async (args, thunkAPI) => {
    const { orderId, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/invoices/validateRfc`,
      method: "post",
      data,
    });
    return { data: response.data };
  }
);

export const sendInvoice = createAsyncThunk(
  "invoice/sendInvoice",
  async (args, thunkAPI) => {
    const { email, invoiceId } = args;
    const response = await axiosInstance.request({
      url: `/invoices/${invoiceId}/send`,
      method: "post",
      params: { email },
    });
    return { data: response.data };
  }
);

export const cancelInvoice = createAsyncThunk(
  "invoice/cancelInvoice",
  async (args, thunkAPI) => {
    const { invoiceId } = args;
    const response = await axiosInstance.request({
      url: `/invoices/${invoiceId}/cancel`,
      method: "post",
    });
    return { data: response.data };
  }
);

export const downloadInvoice = createAsyncThunk(
  "invoice/downloadInvoice",
  async (args) => {
    const { invoiceId, format, filenName } = args;
    const response = await axiosInstance.request({
      url: `/invoices/${invoiceId}/download`,
      method: "get",
      params: { format },
      responseType: "blob",
    });
    const urlFile = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.setAttribute("href", urlFile);
    link.setAttribute("download", `${filenName}.${format}`);
    document.body.appendChild(link);
    link.click();
  }
);

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState: {
    list: {},
    invoice: {},
    loadingSend: false,
    loadingById: false,
    loadingCancel: false,
    loadingIssue: false,
    loadingValidate: false,
    loadingDownload: false,
    loadingStatus: "failed",
    REGIMEN_FISCAL_OPTIONS: [
      {
        label: "601 - General de Ley Personas Morales",
        value: "601",
      },
      {
        label: "603 - Personas Morales con Fines no Lucrativos",
        value: "603",
      },
      {
        label: "605 - Sueldos y Salarios e Ingresos Asimilados a Salarios",
        value: "605",
      },
      {
        label: "606 - Arrendamiento",
        value: "606",
      },
      {
        label: "607- Régimen de Enajenación o Adquisición de Bienes",
        value: "607",
      },
      {
        label: "608 - Demás ingresos",
        value: "608",
      },
      {
        label:
          "610 - Residentes en el Extranjero sin Establecimiento Permanente en México",
        value: "610",
      },
      {
        label: "611 - Ingresos por Dividendos (socios y accionistas)",
        value: "611",
      },
      {
        label:
          "612 - Personas Físicas con Actividades Empresariales y Profesionales",
        value: "612",
      },
      {
        label: "614 - Ingresos por intereses",
        value: "614",
      },
      {
        label: "615 - Régimen de los ingresos por obtención de premios",
        value: "615",
      },
      {
        label: "616 - Sin obligaciones fiscales",
        value: "616",
      },
      {
        label:
          "620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
        value: "620",
      },
      {
        label: "621 - Incorporación Fiscal",
        value: "621",
      },
      {
        label: "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
        value: "622",
      },
      {
        label: "623 - Opcional para Grupos de Sociedades",
        value: "623",
      },
      {
        label: "624 - Coordinados",
        value: "624",
      },
      {
        label:
          "625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
        value: "625",
      },
      {
        label: "626 - Régimen Simplifcado de Confianza",
        value: "626",
      },
    ],
    CFDI_OPTIONS: [
      {
        id: "G01",
        label: "G01 - Adquisición de mercancías.",
        value: "G01",
      },
      {
        id: "G02",
        label: "G02 - Devoluciones, descuentos o bonificaciones.",
        value: "G02",
      },
      {
        id: "G03",
        label: "G03 - Gastos en general",
        value: "G03",
      },
      {
        id: "I01",
        label: "I01 - Construcciones.",
        value: "I01",
      },
      {
        id: "I02",
        label: "I02 - Mobiliario y equipo de oficina por inversiones.",
        value: "I02",
      },
      {
        id: "I03",
        label: "I03 - Equipo de transporte.",
        value: "I03",
      },
      {
        id: "I04",
        label: "I04 - Equipo de computo y accesorios.",
        value: "I04",
      },
      {
        id: "I05",
        label: "I05 - Dados, troqueles, moldes, matrices y herramental.",
        value: "I05",
      },
      {
        id: "I06",
        label: "I06 - Comunicaciones telefónicas.",
        value: "I06",
      },
      {
        id: "I07",
        label: "I07 - Comunicaciones satelitales.",
        value: "I07",
      },
      {
        id: "I08",
        label: "I08 - Otra maquinaria y equipo.",
        value: "I08",
      },
      {
        id: "D01",
        label: "D01 - Honorarios médicos, dentales y gastos hospitalarios.",
        value: "D01",
      },
      {
        id: "D02",
        label: "D02 - Gastos médicos por incapacidad o discapacidad.",
        value: "D02",
      },
      {
        id: "D03",
        label: "D03 - Gastos funerales.",
        value: "D03",
      },
      {
        id: "D04",
        label: "D04 - Donativos",
        value: "D04",
      },
      {
        id: "D05",
        label:
          "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
        value: "D05",
      },
      {
        id: "D06",
        label: "D06 - Aportaciones voluntarias al SAR.",
        value: "D06",
      },
      {
        id: "D07",
        label: "D07 - Primas por seguros de gastos médicos.",
        value: "D07",
      },
      {
        id: "D08",
        label: "D08 - Gastos de transportación escolar obligatoria.",
        value: "D08",
      },
      {
        id: "D09",
        label:
          "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
        value: "D09",
      },
      {
        id: "D10",
        label: "D10 - Pagos por servicios educativos (colegiaturas).",
        value: "D10",
      },
      {
        id: "S01",
        label: "S01 - Sin efectos fiscales.",
        value: "S01",
      },
      {
        id: "CP01",
        label: "CP01 - Pagos",
        value: "CP01",
      },
      {
        id: "CN01",
        label: "CN01 - Nómina",
        value: "CN01",
      },
    ],
    CFDI_OPTIONS_601_603_620_621_622_623_624_626: [
      {
        id: "G01",
        label: "G01 - Adquisición de mercancías.",
        value: "G01",
      },
      {
        id: "G02",
        label: "G02 - Devoluciones, descuentos o bonificaciones.",
        value: "G02",
      },
      {
        id: "G03",
        label: "G03 - Gastos en general",
        value: "G03",
      },
      {
        id: "I01",
        label: "I01 - Construcciones.",
        value: "I01",
      },
      {
        id: "I02",
        label: "I02 - Mobiliario y equipo de oficina por inversiones.",
        value: "I02",
      },
      {
        id: "I03",
        label: "I03 - Equipo de transporte.",
        value: "I03",
      },
      {
        id: "I04",
        label: "I04 - Equipo de computo y accesorios.",
        value: "I04",
      },
      {
        id: "I05",
        label: "I05 - Dados, troqueles, moldes, matrices y herramental.",
        value: "I05",
      },
      {
        id: "I06",
        label: "I06 - Comunicaciones telefónicas.",
        value: "I06",
      },
      {
        id: "I07",
        label: "I07 - Comunicaciones satelitales.",
        value: "I07",
      },
      {
        id: "I08",
        label: "I08 - Otra maquinaria y equipo.",
        value: "I08",
      },
      {
        id: "S01",
        label: "S01 - Sin efectos fiscales.",
        value: "S01",
      },
      {
        id: "CP01",
        label: "CP01 - Pagos",
        value: "CP01",
      },
    ],
    CFDI_OPTIONS_605_608: [
      {
        id: "D01",
        label: "D01 - Honorarios médicos, dentales y gastos hospitalarios.",
        value: "D01",
      },
      {
        id: "D02",
        label: "D02 - Gastos médicos por incapacidad o discapacidad.",
        value: "D02",
      },
      {
        id: "D03",
        label: "D03 - Gastos funerales.",
        value: "D03",
      },
      {
        id: "D04",
        label: "D04 - Donativos",
        value: "D04",
      },
      {
        id: "D05",
        label:
          "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
        value: "D05",
      },
      {
        id: "D06",
        label: "D06 - Aportaciones voluntarias al SAR.",
        value: "D06",
      },
      {
        id: "D07",
        label: "D07 - Primas por seguros de gastos médicos.",
        value: "D07",
      },
      {
        id: "D08",
        label: "D08 - Gastos de transportación escolar obligatoria.",
        value: "D08",
      },
      {
        id: "D09",
        label:
          "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
        value: "D09",
      },
      {
        id: "D10",
        label: "D10 - Pagos por servicios educativos (colegiaturas).",
        value: "D10",
      },
      {
        id: "S01",
        label: "S01 - Sin efectos fiscales.",
        value: "S01",
      },
      {
        id: "CP01",
        label: "CP01 - Pagos",
        value: "CP01",
      },
      {
        id: "CN01",
        label: "CN01 - Nómina",
        value: "CN01",
      },
    ],
    CFDI_OPTIONS_606_612_625: [
      {
        id: "G01",
        label: "G01 - Adquisición de mercancías.",
        value: "G01",
      },
      {
        id: "G02",
        label: "G02 - Devoluciones, descuentos o bonificaciones.",
        value: "G02",
      },
      {
        id: "G03",
        label: "G03 - Gastos en general",
        value: "G03",
      },
      {
        id: "I01",
        label: "I01 - Construcciones.",
        value: "I01",
      },
      {
        id: "I02",
        label: "I02 - Mobiliario y equipo de oficina por inversiones.",
        value: "I02",
      },
      {
        id: "I03",
        label: "I03 - Equipo de transporte.",
        value: "I03",
      },
      {
        id: "I04",
        label: "I04 - Equipo de computo y accesorios.",
        value: "I04",
      },
      {
        id: "I05",
        label: "I05 - Dados, troqueles, moldes, matrices y herramental.",
        value: "I05",
      },
      {
        id: "I06",
        label: "I06 - Comunicaciones telefónicas.",
        value: "I06",
      },
      {
        id: "I07",
        label: "I07 - Comunicaciones satelitales.",
        value: "I07",
      },
      {
        id: "I08",
        label: "I08 - Otra maquinaria y equipo.",
        value: "I08",
      },
      {
        id: "D01",
        label: "D01 - Honorarios médicos, dentales y gastos hospitalarios.",
        value: "D01",
      },
      {
        id: "D02",
        label: "D02 - Gastos médicos por incapacidad o discapacidad.",
        value: "D02",
      },
      {
        id: "D03",
        label: "D03 - Gastos funerales.",
        value: "D03",
      },
      {
        id: "D04",
        label: "D04 - Donativos",
        value: "D04",
      },
      {
        id: "D05",
        label:
          "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
        value: "D05",
      },
      {
        id: "D06",
        label: "D06 - Aportaciones voluntarias al SAR.",
        value: "D06",
      },
      {
        id: "D07",
        label: "D07 - Primas por seguros de gastos médicos.",
        value: "D07",
      },
      {
        id: "D08",
        label: "D08 - Gastos de transportación escolar obligatoria.",
        value: "D08",
      },
      {
        id: "D09",
        label:
          "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
        value: "D09",
      },
      {
        id: "D10",
        label: "D10 - Pagos por servicios educativos (colegiaturas).",
        value: "D10",
      },
      {
        id: "S01",
        label: "S01 - Sin efectos fiscales.",
        value: "S01",
      },
      {
        id: "CP01",
        label: "CP01 - Pagos",
        value: "CP01",
      },
    ],
    CFDI_OPTIONS_607_611_614_615: [
      {
        id: "D01",
        label: "D01 - Honorarios médicos, dentales y gastos hospitalarios.",
        value: "D01",
      },
      {
        id: "D02",
        label: "D02 - Gastos médicos por incapacidad o discapacidad.",
        value: "D02",
      },
      {
        id: "D03",
        label: "D03 - Gastos funerales.",
        value: "D03",
      },
      {
        id: "D04",
        label: "D04 - Donativos",
        value: "D04",
      },
      {
        id: "D05",
        label:
          "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
        value: "D05",
      },
      {
        id: "D06",
        label: "D06 - Aportaciones voluntarias al SAR.",
        value: "D06",
      },
      {
        id: "D07",
        label: "D07 - Primas por seguros de gastos médicos.",
        value: "D07",
      },
      {
        id: "D08",
        label: "D08 - Gastos de transportación escolar obligatoria.",
        value: "D08",
      },
      {
        id: "D09",
        label:
          "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
        value: "D09",
      },
      {
        id: "D10",
        label: "D10 - Pagos por servicios educativos (colegiaturas).",
        value: "D10",
      },
      {
        id: "S01",
        label: "S01 - Sin efectos fiscales.",
        value: "S01",
      },
      {
        id: "CP01",
        label: "CP01 - Pagos",
        value: "CP01",
      },
    ],
    CFDI_OPTIONS_610_616: [
      {
        id: "S01",
        label: "S01 - Sin efectos fiscales.",
        value: "S01",
      },
      {
        id: "CP01",
        label: "CP01 - Pagos",
        value: "CP01",
      },
    ],
  },
  reducers: {
    setInvoiceList: (state, action) => {
      state.list = action.payload;
    },
    clearInvoiceList: (state, action) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceByOrder.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.list = data;
        state.loadingStatus = false;
      })
      .addCase(getInvoiceByOrder.pending, (state, action) => {
        state.loadingStatus = true;
      })
      .addCase(getInvoiceByOrder.rejected, (state, action) => {
        state.loadingStatus = false;
      })
      .addCase(setInvoice.fulfilled, (state, action) => {
        state.loadingIssue = false;
        toast.success("¡Factura emitida correctamente!");
      })
      .addCase(setInvoice.pending, (state, action) => {
        state.loadingIssue = true;
        toast.loading("Emitiendo factura, un momento...");
      })
      .addCase(setInvoice.rejected, (state, action) => {
        state.loadingIssue = false;
        toast.error("Algo salio mal, inténtelo de nuevo más tarde.");
      })
      .addCase(validateRfc.fulfilled, (state, action) => {
        state.loadingValidate = false;
      })
      .addCase(validateRfc.pending, (state, action) => {
        state.loadingValidate = true;
      })
      .addCase(validateRfc.rejected, (state, action) => {
        state.loadingValidate = false;
      })
      .addCase(downloadInvoice.fulfilled, (state, action) => {
        state.loadingDownload = false;
      })
      .addCase(downloadInvoice.pending, (state, action) => {
        state.loadingDownload = true;
      })
      .addCase(downloadInvoice.rejected, (state, action) => {
        state.loadingDownload = false;
      })
      .addCase(sendInvoice.fulfilled, (state, action) => {
        state.loadingSend = false;
      })
      .addCase(sendInvoice.pending, (state, action) => {
        state.loadingSend = true;
      })
      .addCase(sendInvoice.rejected, (state, action) => {
        state.loadingSend = false;
      })
      .addCase(cancelInvoice.fulfilled, (state, action) => {
        state.loadingCancel = false;
      })
      .addCase(cancelInvoice.pending, (state, action) => {
        state.loadingCancel = true;
      })
      .addCase(cancelInvoice.rejected, (state, action) => {
        state.loadingCancel = false;
      })
      .addCase(getInvoiceById.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loadingById = false;
        state.invoice = data;
      })
      .addCase(getInvoiceById.pending, (state, action) => {
        state.loadingById = true;
      })
      .addCase(getInvoiceById.rejected, (state, action) => {
        state.loadingById = false;
      });
  },
});   

export const { setInvoiceList, clearInvoiceList } = invoiceSlice.actions;

export default invoiceSlice.reducer;
